import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import PrimaryContainer from '../../customUI/PrimaryContainer';
import PrimaryButton from '../../customUI/PrimaryButton';
import { authActions } from '../../store/auth-reducer';
import { websiteSwitchActions } from '../../store/website-switch-reducer';
import { websiteAnalyticsActions } from '../../store/website-analytics-reducer';
import { leadsActions } from '../../store/leads-reducer';
import { contentActions } from '../../store/content-reducer';
import { storeContext } from '../provider/Provider';

import check from '../../images/check-icon.svg';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: 20,
    minHeight: 'unset',
    width: '60%',
		marginTop: '30px',
    textAlign: 'center',
    color: '#696969',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  heading: {
    marginTop: 20,
    color: '#696969',
    fontWeight: 600,
		fontSize: 24,
		textAlign: 'center',
		marginBottom: 3,
		width: '70%',
		margin: '20px auto 40px',
		[theme.breakpoints.down('sm')]: {
			fontSize: 24,
      width: '90%',
    },
  },
  button: {
    marginTop: 30,
  },
}));

const ClientCredentials = () => {
  const [cookies] = useCookies(['auth']);
  const history = useHistory();
  const { state, dispatch } = React.useContext(storeContext);
  const classes = useStyles();

  const handleLogout = () => {
    dispatch({ type: authActions.LOGOUT });
    dispatch({ type: websiteSwitchActions.CLEAN_WEBSITE_SWITCH });
    dispatch({ type: websiteAnalyticsActions.WEBSITE_ANALYTICS_CLEAN });
    dispatch({ type: leadsActions.LEADS_CLEAN });
    dispatch({ type: contentActions.CONTENT_CLEAN });
    history.push('/login');
  };

  const handleSupport = () => {
    handleLogout();
    window.open('https://hennessey.com/contact/', '_blank').focus();
  };

  if (!cookies.id_token) {
    history.push('/');
  }

  return (
    <PrimaryContainer className={classes.container}>
      <h1 className={classes.heading}>The Hennessey Digital Platform is currently locked because we have not received full access to your related website accounts yet. Below is the status.</h1>
      <Box display='flex' flexDirection='column' m='20px auto' width='100%' >
        {state.websiteSwitch.currentWebsiteCredentials?.map(item => (
            <Box key={item.name} display='flex' flexDirection='row' alignItems='center' justifyContent='space-between' borderBottom='1px solid #dedede' p={2}>
							<Box>
								{item.name}
								{!item.is_done && item.instructions ? <> - <a rel='noreferrer' target='_blank' title='Instructions' href={item.instructions} style={{ color: '#00B5E2', textDecoration: 'none' }}>Instructions</a></> : null}
							</Box>
							{item.is_done ? <Box width={20}><img alt='Completed' src={check} style={{ width: '100%'}} /></Box> : <Box color='red'>Pending</Box>}
            </Box>
        ))}
      </Box>
      <div className={classes.button}>
        <PrimaryButton
          variant="contained"
          component="span"
          color="primary"
          data-testid="sub_button_test_id"
          style={{ marginRight: 20 }}
          onClick={handleSupport}
          aria-label="support btn"
        >
          Support
        </PrimaryButton>
        <PrimaryButton
          variant="contained"
          component="span"
          color="secondary"
          data-testid="unsub_button_test_id"
          style={{ marginLeft: 20 }}
          onClick={handleLogout}
          aria-label="logOut btn"
        >
          Log Out
        </PrimaryButton>
      </div>
    </PrimaryContainer>
  );
};

export default ClientCredentials;
